'use client';

var __jsx = React.createElement;
import React from 'react';
import { useCustomer } from '@lib/context/shared/customer-context';
import { useTranslations } from 'next-intl';
import Icons from '@modules/icons';
import useCssModules from '@lib/hooks/use-css-modules';
const FooterCurrencyButton = () => {
  var _cssModules$footers$f;
  const t = useTranslations('Shared.LangCurrencyConfig');
  const {
    customerCurrency
  } = useCustomer();
  const {
    cssModules
  } = useCssModules();
  const {
    currencyButtonClassNames,
    currencyButtonIconClassNames
  } = (_cssModules$footers$f = cssModules === null || cssModules === void 0 ? void 0 : cssModules.footers.footerDefault) !== null && _cssModules$footers$f !== void 0 ? _cssModules$footers$f : {};
  return __jsx("button", {
    className: currencyButtonClassNames
  }, __jsx("div", {
    className: "flex items-center gap-2"
  }, __jsx(Icons.currencies, {
    className: currencyButtonIconClassNames
  }), "".concat(t(customerCurrency), " (").concat(customerCurrency, ")")));
};
export default FooterCurrencyButton;